/* Vitadrop — Subscribe "Expanding Plans" (Design F) — v2
   Each row = a supply option: a subscription plan (data-plan set, qty = boxes)
   or the one-time row (data-plan empty, qty 1). Selecting a row expands it and
   updates the CTA; the CTA posts { id, quantity, selling_plan? } and goes to cart.

   Bound by delegation on `document` rather than per-block at load, because this
   markup also arrives long after DOMContentLoaded: the quick view popup writes a
   whole product form in through `innerHTML`, which neither runs the <script> the
   snippet emits nor fires `shopify:section:load`. Delegation plus a repaint when
   a block lands covers the product page and the quick view with one code path —
   and it matters, because subscribe-plans.css hides the theme's own add-to-cart
   wherever this block renders, so these buttons are the only way to add. */
(function () {
  'use strict';

  // The snippet emits its own <script> and layout/theme.liquid loads a deferred
  // copy for pages that only get this markup via the quick view, so on a product
  // page the file is evaluated twice. Bind once.
  if (window.__vdSubPlansBound) return;
  window.__vdSubPlansBound = true;

  var SUB = '[data-vd-sub]';

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  // Selection lives in the DOM (the `on` class Liquid already renders) rather
  // than in a closure, so every function here works on a block it has never seen
  // before — which is exactly the quick view's case.
  function selectedPlan(root) {
    return root.querySelector('[data-vd-plan].on') || root.querySelector('[data-vd-plan]');
  }

  function setText(el, value) {
    if (el && el.textContent !== value) el.textContent = value;
  }

  function paint(root) {
    var current = selectedPlan(root);
    if (!current) return;

    Array.prototype.forEach.call(root.querySelectorAll('[data-vd-plan]'), function (plan) {
      var on = plan === current;
      plan.classList.toggle('on', on);
      var head = plan.querySelector('[data-vd-select]');
      if (head) head.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    setText(root.querySelector('[data-vd-ctaprice]'), money(parseInt(current.dataset.now, 10) || 0));
    setText(root.querySelector('.bx-ctalead'), (current.dataset.plan || '').trim() ? 'Subscribe now' : 'Add to cart');
  }

  function paintAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll(SUB), paint);
  }

  function addToCart(root, item, trigger) {
    if (root.dataset.vdBusy) return;
    root.dataset.vdBusy = '1';

    var cta = root.querySelector('[data-vd-cta]');
    if (cta) { cta.classList.add('is-busy'); cta.disabled = true; }
    if (trigger) trigger.classList.add('is-busy');

    fetch(root.dataset.addUrl || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function () { window.location.href = root.dataset.cartUrl || '/cart'; })
      .catch(function (err) {
        delete root.dataset.vdBusy;
        if (cta) { cta.classList.remove('is-busy'); cta.disabled = false; }
        if (trigger) trigger.classList.remove('is-busy');
        var msg = (err && (err.description || err.message)) || 'Sorry, we could not add that to your cart.';
        window.alert(msg);
      });
  }

  function itemFor(root) {
    var current = selectedPlan(root);
    if (!current) return null;

    var item = {
      id: parseInt(root.dataset.variant, 10),
      quantity: parseInt(current.dataset.qty, 10) || 1
    };
    var planId = (current.dataset.plan || '').trim();
    if (planId) item.selling_plan = parseInt(planId, 10);
    return item;
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var root = target.closest(SUB);
    if (!root) return;

    var head = target.closest('[data-vd-select]');
    if (head) {
      var plan = head.closest('[data-vd-plan]');
      if (!plan) return;
      Array.prototype.forEach.call(root.querySelectorAll('[data-vd-plan]'), function (p) {
        p.classList.toggle('on', p === plan);
      });
      paint(root);
      return;
    }

    if (target.closest('[data-vd-cta]')) {
      event.preventDefault();
      var item = itemFor(root);
      if (item) addToCart(root, item, null);
      return;
    }

    var oneTime = target.closest('[data-vd-onetime]');
    if (oneTime) {
      event.preventDefault();
      addToCart(root, { id: parseInt(root.dataset.variant, 10), quantity: 1 }, oneTime);
    }
  });

  // The CTA price is only ever filled in by paint(), so a block has to be painted
  // once before it is usable. Watch for blocks arriving rather than relying on a
  // load event the quick view never fires. Gated on the added node actually
  // carrying a block, so paint()'s own writes can't re-trigger this.
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches(SUB)) { paint(node); }
          else if (node.querySelector(SUB)) { paintAll(node); }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { paintAll(); });
  } else {
    paintAll();
  }
  document.addEventListener('shopify:section:load', function () { paintAll(); });
})();
